import React, { useState, useEffect, useRef } from "react";
import noteIcon from "./img/note.webp";
import burgerIcon from "./img/menu-burger.png";
import { Button, Form, Row, Col } from "react-bootstrap";

import Modal from "react-bootstrap/Modal";
import { statusfarben } from "./globalVariables";

export default function ProjektstatusGrafik({
   kacheln,
   heading,
   userObjects,
   abschnittsarray,
   showStatusStufen,
   updateStufenOptionen,
   topic,
}) {
   return (
      <div className="projektstatus-l2" style={{ width: "100%" }}>
         <div style={{ position: "relative" }}>
            <button
               onClick={() => updateStufenOptionen({ key: topic, value: true })}
               className="clean-button "
               title="Bereich minimieren"
               style={{ position: "absolute", right: "10px" }}
            >
               _
            </button>
         </div>
         <h2>
            {abschnittsarray && abschnittsarray.length} {heading}
         </h2>
         {abschnittsarray && (
            <div className="projekt-status-expo projektstatus-l3">
               <table>
                  <thead>
                     <tr>
                        <th title="Aktueller Bearbeitungszustand der Stufe">Stufe</th>
                     </tr>
                  </thead>
                  <tbody>
                     {abschnittsarray.map((item) => {
                        return (
                           <tr key={"expokey_" + item.objektnr_extern}>
                              <td className="projektstatus-termin">
                                 <div>
                                    <a
                                       target="_blank"
                                       href={
                                          "/datenblatt?estateid=" +
                                          item.id +
                                          "&stufe=exponachtrag"
                                       }
                                       title="Expo Nachtrag und Kontrolle"
                                       style={{
                                          color:
                                             item.projektstufenstatus.exponachtrag === 4 ||
                                             item.projektstufenstatus.exponachtrag === -1
                                                ? "#fff"
                                                : "#000",
                                          backgroundColor:
                                             item.projektstufenstatus.exponachtrag === -1
                                                ? "#e00"
                                                : statusfarben[item.projektstufenstatus.exponachtrag]
                                                  ? statusfarben[item.projektstufenstatus.exponachtrag]
                                                  : "#fff",
                                       }}
                                    >
                                       EN
                                    </a>
                                 </div>
                              </td>
                              <td>
                                 <a
                                    target="_blank"
                                    title={item.objektbezeichnung}
                                    className="projektstatus-linkbutton me-1"
                                    style={{ fontWeight: 600, fontSize: "16px" }}
                                    href={"/datenblatt?estateid=" + item.id}
                                 >
                                    {(item.objektbezeichnung
                                       ? item.objektnr_extern + " - " + item.objektbezeichnung.slice(0, -5)
                                       : item.objektnr_extern) + " ↗"}
                                 </a>
                              </td>
                           </tr>
                        );
                     })}
                  </tbody>
               </table>
            </div>
         )}
      </div>
   );
}
